import React, { forwardRef } from "react";
import { Box as MuiBox, BoxProps } from "@mui/material";

type BoxCustomProps = {
  component?: string;
} & BoxProps;

const Box = forwardRef<HTMLDivElement, BoxCustomProps>((props, ref) => (
  <MuiBox ref={ref} {...props} />
));

export default Box;
